<template>
    <div class="title-field">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'TitleField',
    }
</script>

<style scoped>
    .title-field {
        font-size: 1.8rem;
        margin-bottom: 12px;
        margin-top: 15px;
        font-weight: 700
    }   
</style>